import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { CopyToClipboard as LibCopyToClipboard } from 'react-copy-to-clipboard'

const PointerHover = styled.div`
	:hover {
		cursor: pointer;
	}
`
export const CopyToClipboard = ({ children, onCopy = () => console.log('Copied!'), text }) => {
	const [copied, setCopied] = useState(false)

	return (
		<LibCopyToClipboard
			text={text}
			onCopy={() => {
				setCopied(true)
				onCopy()
			}}
		>
			<PointerHover>{children}</PointerHover>
		</LibCopyToClipboard>
	)
}
